import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { API } from "../lib/api";
import { loadMetaPixel, trackPageView } from "./metaPixel";

export default function MetaPixel() {
  const location = useLocation();
  useEffect(() => {
    let cancelled = false;
    API.get("/settings/public")
      .then((r) => loadMetaPixel(r.data?.meta_pixel_id))
      .then((enabled) => { if (!cancelled && enabled) trackPageView(location.pathname + location.search); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [location.pathname, location.search]);
  return null;
}
